import script from "./hot-consult.vue?vue&type=script&setup=true&lang=js"
export * from "./hot-consult.vue?vue&type=script&setup=true&lang=js"

import "./hot-consult.vue?vue&type=style&index=0&id=b2885670&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b2885670"]])

export default __exports__